var _excluded = ["body", "secure", "path", "type", "query", "format", "baseUrl", "cancelToken"];
function _inherits(t, e) { if ("function" != typeof e && null !== e)
    throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) {
    var s = _getPrototypeOf(this).constructor;
    e = Reflect.construct(o, arguments, s);
}
else
    e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e))
    return e; if (void 0 !== e)
    throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
}
catch (t) { } return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _regeneratorRuntime() {
    "use strict";
    var r = _regenerator(), e = r.m(_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) { var e = "function" == typeof r && r.constructor; return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name)); }
    var o = { "throw": 1, "return": 2, "break": 3, "continue": 3 };
    function a(r) { var e, t; return function (n) { e || (e = { stop: function stop() { return t(n.a, 2); }, "catch": function _catch() { return n.v; }, abrupt: function abrupt(r, e) { return t(n.a, o[r], e); }, delegateYield: function delegateYield(r, o, a) { return e.resultName = o, t(n.d, _regeneratorValues(r), a); }, finish: function finish(r) { return t(n.f, r); } }, t = function t(r, _t, o) { n.p = e.prev, n.n = e.next; try {
        return r(_t, o);
    }
    finally {
        e.next = n.n;
    } }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n; try {
        return r.call(this, e);
    }
    finally {
        n.p = e.prev, n.n = e.next;
    } }; }
    return (_regeneratorRuntime = function _regeneratorRuntime() { return { wrap: function wrap(e, t, n, o) { return r.w(a(e), t, n, o && o.reverse()); }, isGeneratorFunction: n, mark: r.m, awrap: function awrap(r, e) { return new _OverloadYield(r, e); }, AsyncIterator: _regeneratorAsyncIterator, async: function async(r, e, t, o, u) { return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u); }, keys: _regeneratorKeys, values: _regeneratorValues }; })();
}
function _regeneratorValues(e) { if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
    if (t)
        return t.call(e);
    if ("function" == typeof e.next)
        return e;
    if (!isNaN(e.length))
        return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } };
} throw new TypeError(_typeof(e) + " is not iterable"); }
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n)
    r.unshift(t); return function e() { for (; r.length;)
    if ((t = r.pop()) in n)
        return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _regeneratorAsync(n, e, r, t, o) { var a = _regeneratorAsyncGen(n, e, r, t, o); return a.next().then(function (n) { return n.done ? n.value : a.next(); }); }
function _regeneratorAsyncGen(r, e, t, o, n) { return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise); }
function _regeneratorAsyncIterator(t, e) { function n(r, o, i, f) { try {
    var c = t[r](o), u = c.value;
    return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) { n("next", t, i, f); }, function (t) { n("throw", t, i, f); }) : e.resolve(u).then(function (t) { c.value = t, i(c); }, function (t) { return n("throw", t, i, f); });
}
catch (t) {
    f(t);
} } var r; this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () { return this; })), _regeneratorDefine2(this, "_invoke", function (t, o, i) { function f() { return new e(function (e, r) { n(t, i, e, r); }); } return r = r ? r.then(f, f) : f(); }, !0); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _OverloadYield(e, d) { this.v = e, this.k = d; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _objectWithoutProperties(e, t) { if (null == e)
    return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++)
        o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
} return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r)
    return {}; var t = {}; for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n))
            continue;
        t[n] = r[n];
    } return t; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _classCallCheck(a, n) { if (!(a instanceof n))
    throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
} }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
/** @example {"favorites":["98","98"],"surname":"James","name":"John","email":"john@email.com"} */
/** @example {"result":true} */
/** @example {"keywords":["keywords","keywords"],"backdropUrl":"backdropUrl","production":"production","trailerYoutubeId":"trailerYoutubeId","language":"language","tmdbRating":5,"title":"title","cast":["cast","cast"],"revenue":"revenue","posterUrl":"posterUrl","plot":"plot","genres":["genres","genres"],"id":0,"budget":"budget","languages":["languages","languages"],"releaseDate":"releaseDate","director":"director","awardsSummary":"awardsSummary","runtime":1,"trailerUrl":"trailerUrl","relaseYear":6,"countriesOfOrigin":["countriesOfOrigin","countriesOfOrigin"],"originalTitle":"originalTitle","searchL":"searchL","homepage":"homepage","status":"status"} */
export var ContentType = /*#__PURE__*/ function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["JsonApi"] = "application/vnd.api+json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
    return ContentType;
}({});
export var HttpClient = /*#__PURE__*/ function () {
    function HttpClient() {
        var _this = this;
        var apiConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _classCallCheck(this, HttpClient);
        _defineProperty(this, "baseUrl", '{server}');
        _defineProperty(this, "securityData", null);
        _defineProperty(this, "abortControllers", new Map());
        _defineProperty(this, "customFetch", function () {
            return fetch.apply(void 0, arguments);
        });
        _defineProperty(this, "baseApiParams", {
            credentials: 'same-origin',
            headers: {},
            redirect: 'follow',
            referrerPolicy: 'no-referrer'
        });
        _defineProperty(this, "setSecurityData", function (data) {
            _this.securityData = data;
        });
        _defineProperty(this, "contentFormatters", _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ContentType.Json, function (input) {
            return input !== null && (_typeof(input) === 'object' || typeof input === 'string') ? JSON.stringify(input) : input;
        }), ContentType.JsonApi, function (input) {
            return input !== null && (_typeof(input) === 'object' || typeof input === 'string') ? JSON.stringify(input) : input;
        }), ContentType.Text, function (input) {
            return input !== null && typeof input !== 'string' ? JSON.stringify(input) : input;
        }), ContentType.FormData, function (input) {
            if (input instanceof FormData) {
                return input;
            }
            return Object.keys(input || {}).reduce(function (formData, key) {
                var property = input[key];
                formData.append(key, property instanceof Blob ? property : _typeof(property) === 'object' && property !== null ? JSON.stringify(property) : "".concat(property));
                return formData;
            }, new FormData());
        }), ContentType.UrlEncoded, function (input) {
            return _this.toQueryString(input);
        }));
        _defineProperty(this, "createAbortSignal", function (cancelToken) {
            if (_this.abortControllers.has(cancelToken)) {
                var _abortController = _this.abortControllers.get(cancelToken);
                if (_abortController) {
                    return _abortController.signal;
                }
                return void 0;
            }
            var abortController = new AbortController();
            _this.abortControllers.set(cancelToken, abortController);
            return abortController.signal;
        });
        _defineProperty(this, "abortRequest", function (cancelToken) {
            var abortController = _this.abortControllers.get(cancelToken);
            if (abortController) {
                abortController.abort();
                _this.abortControllers["delete"](cancelToken);
            }
        });
        _defineProperty(this, "request", /*#__PURE__*/ function () {
            var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee2(_ref) {
                var body, secure, path, type, query, format, baseUrl, cancelToken, params, secureParams, requestParams, queryString, payloadFormatter, responseFormat;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1)
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                body = _ref.body, secure = _ref.secure, path = _ref.path, type = _ref.type, query = _ref.query, format = _ref.format, baseUrl = _ref.baseUrl, cancelToken = _ref.cancelToken, params = _objectWithoutProperties(_ref, _excluded);
                                _context2.t1 = (typeof secure === 'boolean' ? secure : _this.baseApiParams.secure) && _this.securityWorker;
                                if (!_context2.t1) {
                                    _context2.next = 6;
                                    break;
                                }
                                _context2.next = 5;
                                return _this.securityWorker(_this.securityData);
                            case 5:
                                _context2.t1 = _context2.sent;
                            case 6:
                                _context2.t0 = _context2.t1;
                                if (_context2.t0) {
                                    _context2.next = 9;
                                    break;
                                }
                                _context2.t0 = {};
                            case 9:
                                secureParams = _context2.t0;
                                requestParams = _this.mergeRequestParams(params, secureParams);
                                queryString = query && _this.toQueryString(query);
                                payloadFormatter = _this.contentFormatters[type || ContentType.Json];
                                responseFormat = format || requestParams.format;
                                return _context2.abrupt("return", _this.customFetch("".concat(baseUrl || _this.baseUrl || '').concat(path).concat(queryString ? "?".concat(queryString) : ''), _objectSpread(_objectSpread({}, requestParams), {}, {
                                    headers: _objectSpread(_objectSpread({}, requestParams.headers || {}), type && type !== ContentType.FormData ? {
                                        'Content-Type': type
                                    } : {}),
                                    signal: (cancelToken ? _this.createAbortSignal(cancelToken) : requestParams.signal) || null,
                                    body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body)
                                })).then(/*#__PURE__*/ function () {
                                    var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee(response) {
                                        var r, responseToParse, data;
                                        return _regeneratorRuntime().wrap(function _callee$(_context) {
                                            while (1)
                                                switch (_context.prev = _context.next) {
                                                    case 0:
                                                        r = response;
                                                        r.data = null;
                                                        r.error = null;
                                                        responseToParse = responseFormat ? response.clone() : response;
                                                        if (responseFormat) {
                                                            _context.next = 8;
                                                            break;
                                                        }
                                                        _context.t0 = r;
                                                        _context.next = 11;
                                                        break;
                                                    case 8:
                                                        _context.next = 10;
                                                        return responseToParse[responseFormat]().then(function (data) {
                                                            if (r.ok) {
                                                                r.data = data;
                                                            }
                                                            else {
                                                                r.error = data;
                                                            }
                                                            return r;
                                                        })["catch"](function (e) {
                                                            r.error = e;
                                                            return r;
                                                        });
                                                    case 10:
                                                        _context.t0 = _context.sent;
                                                    case 11:
                                                        data = _context.t0;
                                                        if (cancelToken) {
                                                            _this.abortControllers["delete"](cancelToken);
                                                        }
                                                        if (response.ok) {
                                                            _context.next = 15;
                                                            break;
                                                        }
                                                        throw data;
                                                    case 15:
                                                        return _context.abrupt("return", data);
                                                    case 16:
                                                    case "end":
                                                        return _context.stop();
                                                }
                                        }, _callee);
                                    }));
                                    return function (_x2) {
                                        return _ref3.apply(this, arguments);
                                    };
                                }()));
                            case 15:
                            case "end":
                                return _context2.stop();
                        }
                }, _callee2);
            }));
            return function (_x) {
                return _ref2.apply(this, arguments);
            };
        }());
        Object.assign(this, apiConfig);
    }
    _createClass(HttpClient, [{
            key: "encodeQueryParam",
            value: function encodeQueryParam(key, value) {
                var encodedKey = encodeURIComponent(key);
                return "".concat(encodedKey, "=").concat(encodeURIComponent(typeof value === 'number' ? value : "".concat(value)));
            }
        }, {
            key: "addQueryParam",
            value: function addQueryParam(query, key) {
                return this.encodeQueryParam(key, query[key]);
            }
        }, {
            key: "addArrayQueryParam",
            value: function addArrayQueryParam(query, key) {
                var _this2 = this;
                var value = query[key];
                return value.map(function (v) {
                    return _this2.encodeQueryParam(key, v);
                }).join('&');
            }
        }, {
            key: "toQueryString",
            value: function toQueryString(rawQuery) {
                var _this3 = this;
                var query = rawQuery || {};
                var keys = Object.keys(query).filter(function (key) {
                    return 'undefined' !== typeof query[key];
                });
                return keys.map(function (key) {
                    return Array.isArray(query[key]) ? _this3.addArrayQueryParam(query, key) : _this3.addQueryParam(query, key);
                }).join('&');
            }
        }, {
            key: "addQueryParams",
            value: function addQueryParams(rawQuery) {
                var queryString = this.toQueryString(rawQuery);
                return queryString ? "?".concat(queryString) : '';
            }
        }, {
            key: "mergeRequestParams",
            value: function mergeRequestParams(params1, params2) {
                return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.baseApiParams), params1), params2 || {}), {}, {
                    headers: _objectSpread(_objectSpread(_objectSpread({}, this.baseApiParams.headers || {}), params1.headers || {}), params2 && params2.headers || {})
                });
            }
        }]);
    return HttpClient;
}();
/**
 * @title Movie API 1.0
 * @version 1.0.0
 * @baseUrl {server}
 * @externalDocs http://swagger.io
 *
 * Данная API предоставляет набор URL, делая запросы на которые Вы получите данные, необходимые для выполнения дипломной работы.
 */
export var Api = /*#__PURE__*/ function (_HttpClient2) {
    _inherits(Api, _HttpClient2);
    var _super = _createSuper(Api);
    function Api() {
        var _this4;
        _classCallCheck(this, Api);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        _this4 = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this4), "auth", {
            /**
             * @description Принимает адрес почты:пароль, открывает новую пользовательскую сессию
             *
             * @tags auth
             * @name AuthLoginPost
             * @summary Логин пользователя по почте:паролю
             * @request POST:/auth/login
             */
            authLoginPost: function authLoginPost(data) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return _this4.request(_objectSpread({
                    path: "/auth/login",
                    method: 'POST',
                    body: data,
                    type: ContentType.UrlEncoded,
                    format: 'json'
                }, params));
            },
            /**
             * No description
             *
             * @tags auth
             * @name AuthLogoutGet
             * @summary Закрытие текущей пользовательской сессии
             * @request GET:/auth/logout
             */
            authLogoutGet: function authLogoutGet() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return _this4.request(_objectSpread({
                    path: "/auth/logout",
                    method: 'GET',
                    format: 'json'
                }, params));
            }
        });
        _defineProperty(_assertThisInitialized(_this4), "user", {
            /**
             * No description
             *
             * @tags auth
             * @name UserPost
             * @summary Регистрация/Создание пользователя
             * @request POST:/user
             */
            userPost: function userPost(data) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return _this4.request(_objectSpread({
                    path: "/user",
                    method: 'POST',
                    body: data,
                    type: ContentType.UrlEncoded,
                    format: 'json'
                }, params));
            }
        });
        _defineProperty(_assertThisInitialized(_this4), "profile", {
            /**
             * No description
             *
             * @tags auth
             * @name ProfileGet
             * @summary Получение данных о текущем авторизованном пользователе
             * @request GET:/profile
             */
            profileGet: function profileGet() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return _this4.request(_objectSpread({
                    path: "/profile",
                    method: 'GET',
                    format: 'json'
                }, params));
            }
        });
        _defineProperty(_assertThisInitialized(_this4), "favorites", {
            /**
             * No description
             *
             * @tags favorites
             * @name FavoritesGet
             * @summary Получение избранных фильмов
             * @request GET:/favorites
             */
            favoritesGet: function favoritesGet() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return _this4.request(_objectSpread({
                    path: "/favorites",
                    method: 'GET',
                    format: 'json'
                }, params));
            },
            /**
             * No description
             *
             * @tags favorites
             * @name FavoritesPost
             * @summary Добавление фильма в избранное
             * @request POST:/favorites
             */
            favoritesPost: function favoritesPost(data) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return _this4.request(_objectSpread({
                    path: "/favorites",
                    method: 'POST',
                    body: data,
                    type: ContentType.UrlEncoded,
                    format: 'json'
                }, params));
            },
            /**
             * No description
             *
             * @tags favorites
             * @name FavoritesMovieIdDelete
             * @summary Удаление фильма из избранного
             * @request DELETE:/favorites/{movieId}
             */
            favoritesMovieIdDelete: function favoritesMovieIdDelete(movieId) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return _this4.request(_objectSpread({
                    path: "/favorites/".concat(movieId),
                    method: 'DELETE',
                    format: 'json'
                }, params));
            }
        });
        _defineProperty(_assertThisInitialized(_this4), "movie", {
            /**
             * No description
             *
             * @tags movies
             * @name MovieGet
             * @summary Получение фильмов по заданным фильтрам
             * @request GET:/movie
             */
            movieGet: function movieGet(query) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return _this4.request(_objectSpread({
                    path: "/movie",
                    method: 'GET',
                    query: query,
                    format: 'json'
                }, params));
            },
            /**
             * No description
             *
             * @tags movies
             * @name MovieTop10Get
             * @summary Получение фильмов с наивысшим рейтингом
             * @request GET:/movie/top10
             */
            movieTop10Get: function movieTop10Get() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return _this4.request(_objectSpread({
                    path: "/movie/top10",
                    method: 'GET',
                    format: 'json'
                }, params));
            },
            /**
             * No description
             *
             * @tags movies
             * @name MovieGenresGet
             * @summary Получение жанров
             * @request GET:/movie/genres
             */
            movieGenresGet: function movieGenresGet() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return _this4.request(_objectSpread({
                    path: "/movie/genres",
                    method: 'GET',
                    format: 'json'
                }, params));
            },
            /**
             * No description
             *
             * @tags movies
             * @name MovieIdGet
             * @summary Получение фильма по id
             * @request GET:/movie/{movieId}
             */
            movieIdGet: function movieIdGet(movieId) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return _this4.request(_objectSpread({
                    path: "/movie/".concat(movieId),
                    method: 'GET',
                    format: 'json'
                }, params));
            },
            /**
             * No description
             *
             * @tags movies
             * @name MovieRandomGet
             * @summary Получение случайного фильма
             * @request GET:/movie/random
             */
            movieRandomGet: function movieRandomGet() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return _this4.request(_objectSpread({
                    path: "/movie/random",
                    method: 'GET',
                    format: 'json'
                }, params));
            }
        });
        return _this4;
    }
    return _createClass(Api);
}(HttpClient);
